var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 129,
  height: 126,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 61.277,
  cy: 60.777,
  r: 60.777,
  fill: "#F5F8FF"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 61.277,
  cy: 60.777,
  r: 47.271,
  fill: "#BDCDD2",
  fillOpacity: 0.37
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33.155 102.448H89.53a3.655 3.655 0 0 0 3.655-3.655V33.42L77.564 19H33.155a3.655 3.655 0 0 0-3.655 3.655v76.138a3.655 3.655 0 0 0 3.655 3.655Z",
  fill: "#F5F8FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.155 20h44.019l15.01 13.857v64.936a2.655 2.655 0 0 1-2.655 2.655H33.155a2.655 2.655 0 0 1-2.655-2.655V22.655a2.656 2.656 0 0 1 2.384-2.641l.271-.014Z",
  stroke: "#8BA7AB",
  strokeOpacity: 0.53,
  strokeWidth: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.285 37.024c0-1.01.818-1.828 1.828-1.828h35.386a1.828 1.828 0 1 1 0 3.656H39.113a1.828 1.828 0 0 1-1.828-1.828Zm0 11.265c0-1.01.818-1.828 1.828-1.828h45.66a1.828 1.828 0 1 1 0 3.655h-45.66a1.828 1.828 0 0 1-1.828-1.827Zm0 11.265c0-1.01.818-1.828 1.828-1.828h12.556a1.828 1.828 0 1 1 0 3.655H39.113a1.828 1.828 0 0 1-1.828-1.827Zm20.547 0c0-1.01.819-1.828 1.828-1.828h25.113a1.828 1.828 0 1 1 0 3.655H59.66a1.828 1.828 0 0 1-1.828-1.827ZM37.285 70.819c0-1.01.818-1.828 1.828-1.828h33.103a1.828 1.828 0 1 1 0 3.655H39.113a1.828 1.828 0 0 1-1.828-1.827Zm41.094 0c0-1.01.819-1.828 1.828-1.828h4.566a1.828 1.828 0 1 1 0 3.655h-4.566a1.828 1.828 0 0 1-1.828-1.827ZM37.285 80.957c0-1.01.818-1.828 1.828-1.828h42.236a1.828 1.828 0 0 1 0 3.656H39.113a1.828 1.828 0 0 1-1.828-1.828Zm0 10.138c0-1.009.818-1.827 1.828-1.827h30.82a1.828 1.828 0 0 1 0 3.655h-30.82a1.828 1.828 0 0 1-1.828-1.828Z",
  fill: "#8BA7AB",
  fillOpacity: 0.53
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.285 37.024c0-1.01.818-1.828 1.828-1.828h35.386a1.828 1.828 0 1 1 0 3.656H39.113a1.828 1.828 0 0 1-1.828-1.828Z",
  fill: "#547D84"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m77.564 19 15.621 14.42h-11.62a4 4 0 0 1-4-4V19ZM63.415 123.958c21.872 0 39.603-1.035 39.603-2.312s-17.73-2.313-39.603-2.313c-21.872 0-39.602 1.036-39.602 2.313 0 1.277 17.73 2.312 39.602 2.312Z",
  fill: "#8BA7AB",
  fillOpacity: 0.53
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m84.24 87.778 5.95-5.95 24.52 20.929a6.767 6.767 0 0 1 .392 9.934 6.768 6.768 0 0 1-9.934-.392l-20.929-24.52Z",
  fill: "#30636B"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m88.465 92.728 16.704 19.571a6.768 6.768 0 0 0 9.934.392 6.767 6.767 0 0 0-.392-9.934L92.864 84.11a24.338 24.338 0 0 1-4.4 8.618Z",
  fill: "#547D84"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m77.445 52.07-15.38 35.708a19.666 19.666 0 0 1-4.543-4.947l13.285-30.844a18.99 18.99 0 0 1 6.638.083ZM88.378 58.265l-14.46 33.573c-3.005.003-5.969-.7-8.664-2.055l15.79-36.661a19.624 19.624 0 0 1 7.334 5.143Z",
  fill: "#fff"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.127 57.006a17.113 17.113 0 0 0-6.364 7.585 17.638 17.638 0 0 0-1.177 9.961 17.395 17.395 0 0 0 4.424 8.936 16.688 16.688 0 0 0 8.486 4.89c3.23.733 6.6.47 9.688-.755a16.739 16.739 0 0 0 5.526-3.597 17.235 17.235 0 0 0 3.773-5.506 17.626 17.626 0 0 0 .285-13.225 17.168 17.168 0 0 0-6.034-7.868 16.507 16.507 0 0 0-9.242-3.097 16.476 16.476 0 0 0-9.365 2.676ZM53.59 62.362a22.747 22.747 0 0 1 8.465-10.078 22.11 22.11 0 0 1 12.565-3.587 22.14 22.14 0 0 1 12.396 4.15 22.802 22.802 0 0 1 8.019 10.446 23.26 23.26 0 0 1-.377 17.456 22.869 22.869 0 0 1-5.008 7.306 22.374 22.374 0 0 1-7.385 4.804 22.026 22.026 0 0 1-13.015 1.013 22.322 22.322 0 0 1-11.353-6.534 23.028 23.028 0 0 1-5.863-11.83 23.271 23.271 0 0 1 1.556-13.146Z",
  fill: "#547D84"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M112.511 102.952 94.845 88.486c-.548-.449-1.186.182-.742.733l14.265 17.744c.551.684 1.346 1.129 2.173 1.216l.49.051c1.692.177 2.965-1.16 2.715-2.852l-.058-.393c-.114-.776-.54-1.511-1.177-2.033Z",
  fill: "#30636B"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22.919,
  height: 3.951,
  rx: 1.976,
  transform: "scale(-1 1) rotate(45 -115.193 -66.42)",
  fill: "#547D84"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 22.919,
  height: 3.951,
  rx: 1.976,
  transform: "scale(1 -1) rotate(-45 -45.963 -110.255)",
  fill: "#547D84"
})));
export default SvgNotFound;